import { CountUp } from 'countup.js';

export default function (app: any) {
  app.directive('fadeIn', {
    mounted(el: HTMLDivElement, binding: any) {
      const delay = binding.value ?? 500
      el.style.transition = 'all 0.5s'
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const intersectionRatio = entry.intersectionRatio;
          const y = entry.rootBounds?.y
          const isIntersectingFromTop = entry.boundingClientRect?.y < y!;
          if (intersectionRatio < 0 || !isIntersectingFromTop) {
            if (entry.isIntersecting) {
              setTimeout(() => {
                el.style.opacity = '1';
              }, delay);
            } else {
              el.style.opacity = '0';
            }
          } else {
            setTimeout(() => {
              el.style.opacity = '1';
            }, delay);
          }
        });
      });

      observer.observe(el);
    },

  });

  app.directive('translateIn', {
    mounted(el: HTMLDivElement, binding: any) {
      el.style.transition = 'all 0.5s'
      const time = binding.value ?? 50
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const intersectionRatio = entry.intersectionRatio;
          const y = entry.rootBounds?.y
          const isIntersectingFromTop = entry.boundingClientRect?.y < y!;
          if (intersectionRatio < 0 || !isIntersectingFromTop) {
            if (entry.isIntersecting) {
              setTimeout(() => {
                el.style.opacity = '1';
                el.style.transform = 'translateY(0%)'
              }, time);
            } else {
              el.style.opacity = '0';
              el.style.transform = 'translateY(30%)'
            }
          } else {
            setTimeout(() => {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0%)'
            }, time);
          }
        });
      });

      observer.observe(el);
    }
  });

  app.directive('slideIn', {
    mounted(el: HTMLDivElement, binding: any) {
      el.style.transition = 'all 0.5s'
      const time = 50
      const direction = binding.value
      if(direction === 'none') return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const intersectionRatio = entry.intersectionRatio;
          const y = entry.rootBounds?.y
          const isIntersectingFromTop = entry.boundingClientRect?.y < y!;
          if (intersectionRatio < 0 || !isIntersectingFromTop) {
            if (entry.isIntersecting) {
              setTimeout(() => {
                el.style.transform = 'translateX(0%)'
              }, time);
            } else {
              el.style.transform = direction === 'left' ? 'translateX(100%)' : 'translateX(-100%)'
            }
          } else {
            setTimeout(() => {
              el.style.transform = 'translateX(0%)'
            }, time);
          }
        });
      });

      observer.observe(el);
    }
  });

  // app.directive('writeIn', {
  //   mounted(el: HTMLDivElement, binding: { value: string }) {
  //     const instance = new Typed(el, {
  //       strings: [binding.value],
  //       typeSpeed: 50,
  //       backSpeed: 25,
  //       backDelay: 500,
  //       loop: false,
  //       showCursor: false,
  //       autoInsertCss: false
  //     });
      
  //     // Store the instance on the element for reuse
  //     Reflect.set(el, '_typedInstance', instance)

  //     const observer = new IntersectionObserver(entries => {
  //       entries.forEach(entry => {
  //         const y = entry.rootBounds?.y;
  //         const isIntersectingFromTop = entry.boundingClientRect?.y > (y || 0);
  //         if (entry.isIntersecting && isIntersectingFromTop) {
  //           instance.reset();
  //         }
  //       });
  //     });

  //     observer.observe(el);
  //   },
  //   updated(el: HTMLDivElement, binding: { value: string }) {
  //     // Update the strings of the existing Typed instance
  //     const typeInstance = Reflect.get(el, '_typedInstance')
  //     if (typeInstance) {
  //       typeInstance.strings = [binding.value];
  //       typeInstance.reset(); // Reset to start typing the new strings
  //     }
  //     el.textContent = binding.value; // Update text content
  //   }
  // })

  app.directive('countUp', {
    mounted(el: HTMLDivElement, binding: { value: number }) {
      const decimalPlaces = (binding.value.toString().split('.')[1] || '').length;
      const instance = new CountUp(el, binding.value, {
        duration: 3,
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimalPlaces,
      });
      let firstCount = 0;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const y = entry.rootBounds?.y;
          const isIntersectingFromTop = entry.boundingClientRect?.y > (y || 0);
          if (entry.isIntersecting && (firstCount == 0 || isIntersectingFromTop)) {
            instance.reset();
            instance.start();
            firstCount += 1;
          }
        });
      });

      observer.observe(el);
    },
  })
}